<div class="galaxy m-0 d-flex ">
   <div class="sidebar p-0">
      <app-aside></app-aside>
   </div>
   <div class=" p-0 dashboard_comp">
      <p>
         <router-outlet></router-outlet>
      </p>
   </div>
</div>


